import { TableCell, Typography, useTheme } from "@mui/material";
import { useColorMode } from "~/providers/color-mode";

export interface SlaCellProps {
  type: "AtRisk" | "Overdue";
  value: number;
}

export function SlaCell({ type, value }: SlaCellProps) {
  const theme = useTheme();
  const { mode } = useColorMode();
  const color =
    type === "AtRisk"
      ? theme.palette.warning[mode === "light" ? "dark" : "main"]
      : theme.palette.critical.light;
  return (
    <TableCell>
      <Typography sx={{ fontSize: 14, fontWeight: 700, color }}>
        {value}
      </Typography>
    </TableCell>
  );
}
